// SPA-side <Link> to a stale path lands here without BE redirect lookup. Reload once so BE
// can check; remember the path so we don't loop on confirmed 404s.
import { useEffect, useState } from 'react'

import NotFoundPortal from './NotFoundPortal'

const STORAGE_KEY = 'csPortalNotFoundChecked'

const NotFoundPortalGate: React.FC = () => {
  const [confirmed, setConfirmed] = useState(false)

  useEffect(() => {
    const path = window.location.pathname
    if (sessionStorage.getItem(STORAGE_KEY) === path) {
      setConfirmed(true)
      return
    }
    sessionStorage.setItem(STORAGE_KEY, path)
    window.location.replace(window.location.href)
  }, [])

  if (!confirmed) {
    return null
  }

  return <NotFoundPortal />
}

export default NotFoundPortalGate
